import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Paper, } from '@mui/material';
var ConfirmDialog = function (_a) {
    var open = _a.open, title = _a.title, content = _a.content, _b = _a.okText, okText = _b === void 0 ? 'OK' : _b, onClick = _a.onClick;
    var handleClose = function (_event, reason) {
        if (reason && reason === 'backdropClick') {
            return;
        }
        onClick();
    };
    return (_jsxs(Dialog, { open: open, onClose: handleClose, disableEscapeKeyDown: true, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", PaperComponent: Paper, PaperProps: { sx: { borderRadius: '0.25rem', padding: '8px' } }, children: [_jsx(DialogTitle, { children: title }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: content }) }), _jsx(DialogActions, { children: _jsx(Button, { onClick: onClick, color: "primary", autoFocus: true, children: okText }) })] }));
};
export default ConfirmDialog;
